import React from "react";

import "./counter.scss";

const Counter: React.FC<{
  hours: string;
  minutes: string;
  seconds: string;
}> = ({ hours, minutes, seconds }) => {
  return (
    <div>
      <div className="d-flex justify-content-center">
        <img
          className="logo-counter"

          src="/img/zefi-logo.svg"
        />
      </div>
      <div  className="d-flex justify-content-center counter" >
        {hours}:{minutes}:{seconds}</div>
    </div>
  );
};

export default Counter;
